import { useMemo } from 'react';
import { ApiFilterMetaObj, ApiFilterMeta } from 'types';
import { SearchFilterMeta, SearchFiltersMeta } from '../types';

const convertToSearchFilterMeta = (
    metaData?: ApiFilterMeta,
): SearchFilterMeta | undefined => {
    if (!metaData) {
        return undefined;
    }

    return Object.fromEntries(
        metaData.map((data) => {
            return [data.name, data.value];
        }),
    );
};

const useSearchFiltersMeta = ({
    filterMetaObj,
}: {
    filterMetaObj?: ApiFilterMetaObj;
}): SearchFiltersMeta => {
    const filterInstrumentsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.instrumentFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(filterMetaObj?.instrumentFilters)],
    );

    const filterGenresMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.genreFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(filterMetaObj?.genreFilters)],
    );

    const filterTypesMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.sampleTypeFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(filterMetaObj?.sampleTypeFilters)],
    );

    const filterSfxsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.sfxFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(filterMetaObj?.sfxFilters)],
    );

    const filterTagsMeta = useMemo(
        () => convertToSearchFilterMeta(filterMetaObj?.tagFilters),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(filterMetaObj?.tagFilters)],
    );

    return {
        filterInstrumentsMeta,
        filterGenresMeta,
        filterTypesMeta,
        filterSfxsMeta,
        filterTagsMeta,
    };
};

export default useSearchFiltersMeta;
